
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.text.platform.Typeface
import org.jetbrains.skia.Data
import org.jetbrains.skia.Typeface
import org.jetbrains.skiko.loadBytesFromPath


//actual suspend fun getDefaultFontFamily(): FontFamily {
//    return loadCustomFonts("league_spartan")
//}
suspend fun loadCustomFonts(fontName: String): FontFamily {
    val fontBytes = loadBytesFromPath("fonts/$fontName.ttf")
    val skTypeface: Typeface = Typeface.makeFromData(Data.makeFromBytes(fontBytes))
    return FontFamily(Typeface(skTypeface))
}